import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';

import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import MyAccount from '../../views/Pages/MyAccount';
import ChangePassword from '../../views/Pages/ChangePassword'
import TwoFASetting from '../../views/Pages/TwoFASetting'
import AdminUser from '../../views/Admin/AdminUser'
import ActivityLog from '../../views/Admin/ActivityLog'
import ActivityLogType from '../../views/Admin/ActivityLog/ActivityLogType'

import Setting from '../../views/Setting';
import Role from '../../views/Role';
import RoleEdit from '../../views/Role/RoleEdit';
import NganhHang from '../../views/NganhHang';
import NganhHangEdit from '../../views/NganhHang/NganhHangEdit';
import MucHopDong from '../../views/MucHopDong';
import MucHopDongEdit from '../../views/MucHopDong/MucHopDongEdit';
import NhaCungCap from '../../views/NhaCC';
import NhaCungCapEdit from '../../views/NhaCC/NhaCCEdit';
import Kho from '../../views/Kho';
import KhoEdit from '../../views/Kho/KhoEdit';
import Products from '../../views/Products';
import ProductsEdit from '../../views/Products/ProductsEdit';
import NguoiDungKho from '../../views/NguoiDungKho';
import Orders from '../../views/Orders';
import ProcessOrders from '../../views/ProcessOrders';
import Order from '../../views/Order';
import OrderDetails from '../../views/Order/OrderDetails';
import ProcessOrderDetails from '../../views/ProcessOrders/ProcessOrderDetails';
import ProcessOrderCheckQR from '../../views/ProcessOrders/ProcessOrderCheckQR';
import ProcessOrderChecked from '../../views/ProcessOrders/ProcessOrderChecked';
import ChuongTrinh from '../../views/ChuongTrinh';
import ChuongTrinhEdit from '../../views/ChuongTrinh/ChuongTrinhEdit';
import ChuongTrinhProduct from '../../views/ChuongTrinh/ChuongTrinhProduct';
import NguoiDungRole from '../../views/NguoiDungRole';
import PermissionRole from '../../views/PermissionRole';
import Khachhang from '../../views/KhachHang';
import KhachhangEdit from '../../views/KhachHang/KhachhangEdit';
import KhachhangUser from '../../views/KhachHang/KhachhangUser';
import TonKho from '../../views/TonKho';
import TonkhoEdit from '../../views/TonKho/TonKhoEdit';
import GuestReport from '../../views/Reports/GuestReport';
import ImportReport from '../../views/Reports/ImportReport';
import OrderReport from '../../views/Reports/OrderReport';
import SaleDetailReport from '../../views/Reports/SaleDetailReport';
import SaleTotalReport from '../../views/Reports/SaleTotalReport';
import SaleReport from '../../views/Reports/SaleReport';

import Imports from '../../views/LsNhapKho';
import nhapkho from '../../views/NhapKho';
import nhapkhoEdit from '../../views/NhapKho/NhapKhoEdit';
import GiaoHang from '../../views/GiaoHang';
import GiaoHangEdit from '../../views/GiaoHang/GiaoHangEdit';
import CongNo from '../../views/CongNo';
import CongNoKH from '../../views/CongNo/CongNoKH';
import CongNoHD from '../../views/CongNo/CongNoHD';
import Contracts from '../../views/Contracts';
import EditContract from '../../views/Contracts/EditContract';
import TraHang from '../../views/TraHang';
import AppLoader from './_AppLoader'
import { getData } from './actions'
import EnvConfig from '../../config/env'
import Checkin from '../../views/Checkin/Checkin';
import CheckinReport from '../../views/Checkin/CheckinReport';

class Full extends Component {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    document.title = EnvConfig.PAGE_TITLE
  }
  componentWillMount() {
    this.props.getData()
  }
  render() {
    const {
      requesting,
      tokenIsLive
    } = this.props

    if (requesting) {
      return (
        <AppLoader />
      )
    }

    if (!tokenIsLive) {
      return (
        <Redirect from="/" to="/login" />
      )
    }

    return (
      <div className="app">
        <Header {...this.props} />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main bg-white">
            <Breadcrumb />
            <Container fluid>
              <Switch {...this.props}>
                <Route path="/dashboard" name="Dashboard" component={Dashboard} />
                <Route path="/myaccount" name="MyAccount" component={MyAccount} />
                <Route path="/changepassword" name="ChangePassword" component={ChangePassword} />
                <Route path="/twofasetting" name="TwoFASetting" component={TwoFASetting} />
                <Route path="/users" name="AdminUser" component={AdminUser} />
                <Route path="/activities" name="ActivityLog" component={ActivityLog} />
                <Route path="/activity-types" name="ActivityLogType" component={ActivityLogType} />
                <Route path="/roles" name="Role" component={Role} />
                <Route path="/role-edit" name="RoleEdit" component={RoleEdit} />
                <Route path="/nganhhang" name="NganhHang" component={NganhHang} />
                <Route path="/nganhhang-edit" name="NganhHangEdit" component={NganhHangEdit} />
                <Route path="/muchopdong" name="NganhHang" component={MucHopDong} />
                <Route path="/muchopdong-edit" name="NganhHangEdit" component={MucHopDongEdit} />
                <Route path="/nhacungcap" name="NhaCungCap" component={NhaCungCap} />
                <Route path="/nhacungcap-edit" name="NhaCungCapEdit" component={NhaCungCapEdit} />
                <Route path="/kho" name="Kho" component={Kho} />
                <Route path="/kho-edit" name="KhoEdit" component={KhoEdit} />
                <Route path="/products" name="Products" component={Products} />
                <Route path="/products-edit" name="ProductsEdit" component={ProductsEdit} />
                <Route path="/nguoidung-kho" name="NguoiDungKho" component={NguoiDungKho} />
                <Route path="/nguoidung-role" name="NguoiDungRole" component={NguoiDungRole} />
                <Route path="/permission-role" name="NguoiDungRole" component={PermissionRole} />
                <Route path="/chuong-trinh" name="ChuongTrinh" component={ChuongTrinh} />
                <Route path="/chuong-trinh-edit" name="ChuongTrinhEdit" component={ChuongTrinhEdit} />
                <Route path="/chuong-trinh-product" name="ChuongTrinhProduct" component={ChuongTrinhProduct} />
                <Route path="/imports" name="Imports" component={Imports} />
                <Route path="/nhap-kho-edit/:nhap?" name="nhapkhoEdit" component={nhapkhoEdit} />
                <Route path="/orders/:type(1|2)/:status" name="Orders" component={Orders} />
                <Route path="/orders/:type(1|2)" name="Orders" component={Orders} />
                <Route path="/processorders" name="ProcessOrders" component={ProcessOrders} />
                <Route path="/order/:type(1|2)" name="Order" component={Order} />
                <Route path="/order-edit/:type(1|2)/:id" name="OrderEdit" component={Order} />
                <Route path="/order-view/:type(1|2|3)/:id" name="OrderView" component={OrderDetails} />
                <Route path="/process-order-detail/:id" name="ProcessOrderDetails" component={ProcessOrderDetails} />
                <Route path="/process-order-checkqr/:id" name="ProcessOrderCheckQR" component={ProcessOrderCheckQR} />
                <Route path="/process-order-checked" name="ProcessOrderChecked" component={ProcessOrderChecked} />
                <Route path="/nhap-kho" name="nhapkho" component={nhapkho} />
                <Route path="/khachhang" name="Khachhang" component={Khachhang} />
                <Route path="/khachhang-edit" name="KhachhangEdit" component={KhachhangEdit} />
                <Route path="/khachhang-user" name="KhachhangUser" component={KhachhangUser} />
                <Route path="/tonkho" name="TonKho" component={TonKho} />
                <Route path="/tonkho-edit" name="TonkhoEdit" component={TonkhoEdit} />
                <Route path="/import-report" name="ImportReport" component={ImportReport} />
                <Route path="/guest-report" name="GuestReport" component={GuestReport} />
                <Route path="/order-report" name="OrderReport" component={OrderReport} />
                <Route path="/sale-detail-report" name="SaleDetailReport" component={SaleDetailReport} />
                <Route path="/sale-total-report" name="SaleTotalReport" component={SaleTotalReport} />
                <Route path="/sale-report" name="SaleReport" component={SaleReport} />
                <Route path="/giaohang" name="GiaoHang" component={GiaoHang} />
                <Route path="/giaohang-edit" name="GiaoHangEdit" component={GiaoHangEdit} />
                <Route path="/congno" name="CongNo" component={CongNo} />
                <Route path="/congnokh/:tuNgay/:denNgay/:maKH" name="congNoKh" component={CongNoKH} />
                <Route path="/congnohd/:maHD" name="congNoHD" component={CongNoHD} />
                <Route path="/hop-dong" name="Contracts" component={Contracts} />
                <Route path="/chi-tiet-hop-dong" name="EditContract" component={EditContract} />
                <Route path="/tra-hang/:type(1|2)/:id" name="TraHang" component={TraHang} />
                <Route path="/setting" name="Setting" component={Setting} />
                <Route path="/checkin" name="Checkin" component={Checkin} />
                <Route path="/checkin-report" name="CheckinReport" component={CheckinReport} />
                <Redirect from="/" to="/dashboard" />
              </Switch>
            </Container>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    client: state.client,
    tokenIsLive: state.global.tokenIsLive,
    requesting: state.global.requesting,
    successful: state.global.successful,
  }
}

const connected = connect(
  mapStateToProps,
  {
    getData: getData
  })(Full)

export default connected;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js